import { render, staticRenderFns } from "./platformCustomizedMaterialsModal.vue?vue&type=template&id=0919f028&scoped=true"
import script from "./platformCustomizedMaterialsModal.vue?vue&type=script&lang=js"
export * from "./platformCustomizedMaterialsModal.vue?vue&type=script&lang=js"
import style0 from "./platformCustomizedMaterialsModal.vue?vue&type=style&index=0&id=0919f028&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0919f028",
  null
  
)

export default component.exports